import {
  Select,
  MenuItem,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  CircularProgress,
  Tabs,
  Tab,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import moment from "moment";

import DateRangePicker from "../dateRangePicker";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../redux/slices/common.slice";
import {
  getAuditCountThunk,
  getDashboardReportCountThunk,
  getDashboardSafetyBuddyCountThunk,
  getProjectSelectionThunk,
  getServiceTaskCountThunk,
} from "../../../redux/slices/tenant.slice";
import { getDashboardCountThunk } from "../../../redux/slices/tenant.slice";
import { useLocation, useNavigate } from "react-router-dom";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";
import OfflineExporting from "highcharts/modules/offline-exporting";
import { getAllServiceUnit } from "../../../redux/slices/serviceUnit.slice";
import Modal from "../insightDatamodal";
import { useSelector } from "react-redux";

Exporting(Highcharts);
OfflineExporting(Highcharts);
ExportData(Highcharts);

const Insights = () => {
  let currentDate = new Date();
  let firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );

  firstDayOfMonth = moment(firstDayOfMonth).format("MM-DD-YYYY");
  currentDate = moment(currentDate).format("MM-DD-YYYY");

  // Report related date range
  const [dateRange, setDateRange] = useState([firstDayOfMonth, currentDate]);
  const [userTypeFilter, setUserTypeFilter] = useState("all");
  const [projectFilter, setProjectFilter] = useState("all");

  // report inside date range
  const [reportInsideDateRange, setReportInsideDateRange] = useState([
    firstDayOfMonth,
    currentDate,
  ]);
  const [reportInsideUserFilter, setReportInsideUserFilter] = useState("all");
  const [reportInsideProjectFilter, setReportInsideProjectFilter] =
    useState("all");
  const [reportInsideData, setReportInsideData] = useState([]);

  const [safetyBudddyReportData, setSafetyBudddyReportData] = useState([]);

  const [projectData, setProjectData] = useState([]);
  const [serviceUnits, setServiceUnits] = useState([]);
  const [dashboardCount, setDashboardCount] = useState({});

  const [serviceUnitData, setServiceUnitData] = useState([]);
  const [serviceUserTypeFilter, setServiceUserTypeFilter] = useState("all");
  const [serviceProjectFilter, setServiceProjectFilter] = useState("all");
  const [auditData, setAuditData] = useState([]);
  const [auditUserTypeFilter, setAuditUserTypeFilter] = useState("all");
  const [auditProjectFilter, setAuditProjectFilter] = useState("all");

  const [auditDateRange, setAuditDateRange] = useState([
    firstDayOfMonth,
    currentDate,
  ]);
  const [serviceDateRange, setServiceDateRange] = useState([
    firstDayOfMonth,
    currentDate,
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [graphTitle, setGraphTitle] = useState("");

  const [countLoading, setCountLoading] = useState(true);
  const [safetyBuddyLoading, setSafetyBuddyLoading] = useState(true);
  const [reportLoading, setReportLoading] = useState(true);
  const [serviceUnitLoading, setServiceUnitLoading] = useState(true);
  const [auditLoading, setAuditLoading] = useState(true);
  const users = useSelector((state) => state.common.users);
  const [mainTabsafety, setMainTabsafety] = useState(0);
  const [mainTabReport, setMainTabReport] = useState(0);
  const [mainTabEquipment, setMainTabEquipment] = useState(0);
  const [mainTabAudit, setMainTabAudit] = useState(0);
  let userData = [{ label: "All User", value: "all" }, ...users];
  const showTablePopup = (tableHTML) => {
    setModalContent(tableHTML);
    setIsModalOpen(true);
  };

  const navigate = useNavigate();
  const location = useLocation();

  const handleReportInsideDateRange = (newDateRange) => {
    setReportInsideDateRange(newDateRange);
  };
  const handleServiceDateRange = (newDateRange) => {
    setServiceDateRange(newDateRange);
  };
  const handleAuditDateRange = (newDateRange) => {
    setAuditDateRange(newDateRange);
  };

  const updateData = (data, countArray1, countArray2, countArray3, x_label) => {
    data.forEach((item) => {
      const monthIndex = x_label.indexOf(item.month);
      if (monthIndex === -1) {
        // If month is not in x_label, add it and initialize counts for all categories
        x_label.push(item.month);
        countArray1.push(item.count || 0);
        countArray2.push(0);
        countArray3.push(0);
      } else {
        // If month already exists, update only the relevant count array
        countArray1[monthIndex] = item.count || countArray1[monthIndex];
      }
    });
  };

  const highlightScope = {
    highlighted: "series",
    faded: "global",
  };

  const dispatch = useDispatch();

  const fetchAllServiceUnits = async () => {
    let response = await dispatch(
      getAllServiceUnit({
        page_number: 1,
      })
    );
    const { payload } = response;
    if (payload?.status) {
      let temp = [{ label: "All Equipments", value: "all" }];

      payload?.data?.map((element) => {
        temp.push({
          label: `${element?.name}`,
          value: element?.id,
        });
        setServiceUnits(temp);
      });
    } else
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: payload?.message || "Internal server error",
        })
      );
  };

  // Fetch all porojet selection related information
  const fetchAllProject = async () => {
    let response = await dispatch(getProjectSelectionThunk());

    const { payload } = response;

    if (payload?.status) {
      let temp = [{ label: "All Site", value: "all" }];
      payload?.data?.project?.map((element) => {
        temp.push({
          label: element?.name,
          value: element?.id,
        });
      });
      setProjectData(temp);
    }
  };

  const fetchDashboardCount = async () => {
    setCountLoading(true);
    let response = await dispatch(getDashboardCountThunk({}));
    const { payload } = response;

    if (payload?.status) {
      setDashboardCount(payload?.data);
      setCountLoading(false);
    } else {
      setCountLoading(false);
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: payload?.message || "Internal server error",
        })
      );
    }
  };

  const fetchDashboardReportCount = async () => {
    setReportLoading(true);
    let send_payload = {};
    if (reportInsideDateRange?.length > 0) {
      send_payload["start"] =
        reportInsideDateRange[0] == ""
          ? undefined
          : moment(reportInsideDateRange[0]).format("YYYY-MM-DD");
      send_payload["to"] =
        reportInsideDateRange[1] == ""
          ? undefined
          : moment(reportInsideDateRange[1]).format("YYYY-MM-DD");
    }

    if (reportInsideUserFilter !== "all") {
      send_payload["user_id"] = reportInsideUserFilter;
    }
    if (reportInsideProjectFilter !== "all") {
      send_payload["project_id"] = reportInsideProjectFilter;
    }
    if (mainTabReport === 1) send_payload["interval_type"] = "month";
    else send_payload["interval_type"] = "day";

    let response = await dispatch(getDashboardReportCountThunk(send_payload));
    const { payload } = response;

    if (payload?.status) {
      setReportLoading(false);
      if (mainTabReport === 1) {
        const x_label = [];
        const pending_count = [];
        const completed_count = [];
        const in_review_count = [];

        updateData(
          payload?.data?.pending || [],
          pending_count,
          completed_count,
          in_review_count,
          x_label
        );
        updateData(
          payload?.data?.completed || [],
          completed_count,
          pending_count,
          in_review_count,
          x_label
        );
        updateData(
          payload?.data?.in_review || [],
          in_review_count,
          pending_count,
          completed_count,
          x_label
        );
        const series = [
          {
            name: "Pending Task",
            data: pending_count,
            color: "red", // Blue for In Review
          },
          {
            name: "Completed Task",
            data: completed_count,
            color: "green", // Green for Completed
          },
          {
            name: "In-review Task",
            data: in_review_count,
            color: "orange", // Blue for In Review
          },
        ];
        setReportInsideData({
          x_label,
          series,
        });
      } else {
        let tempData = [
          {
            id: 0,
            value: payload?.data?.approved_report,
            label: "Completed Report",
            color: "green",
          },
          {
            id: 1,
            value: payload?.data?.pending_report,
            label: "Pending Report",
            color: "red",
          },
          {
            id: 2,
            value: payload?.data?.in_review || 0,
            label: "In Review Report",
            color: "orange",
          },
        ];

        setReportInsideData(tempData);
      }
    } else {
      setReportLoading(false);
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: payload?.message || "Internal server error",
        })
      );
    }
  };
  const fetchServiceUnitData = async () => {
    setServiceUnitLoading(true);
    let send_payload = {};
    if (serviceDateRange?.length > 0) {
      send_payload["start"] =
        serviceDateRange[0] == ""
          ? undefined
          : moment(serviceDateRange[0]).format("YYYY-MM-DD");
      send_payload["to"] =
        serviceDateRange[1] == ""
          ? undefined
          : moment(serviceDateRange[1]).format("YYYY-MM-DD");
    }

    if (serviceUserTypeFilter !== "all") {
      send_payload["users"] = serviceUserTypeFilter;
    }
    if (serviceProjectFilter !== "all") {
      send_payload["service_unit_id"] = serviceProjectFilter;
    }
    if (mainTabEquipment === 1) send_payload["interval_type"] = "month";
    else send_payload["interval_type"] = "day";

    let response = await dispatch(getServiceTaskCountThunk(send_payload));
    const { payload } = response;

    if (payload?.status) {
      setServiceUnitLoading(false);
      if (mainTabEquipment === 1) {
        const x_label = [];
        const upcoming_count = [];
        const completed_count = [];
        const pending_count = [];

        updateData(
          payload?.data?.inspection?.up_coming || [],
          upcoming_count,
          completed_count,
          pending_count,
          x_label
        );
        updateData(
          payload?.data?.inspection?.completed || [],
          completed_count,
          upcoming_count,

          pending_count,
          x_label
        );
        updateData(
          payload?.data?.inspection?.pending || [],
          pending_count,
          upcoming_count,
          completed_count,
          x_label
        );
        const series = [
          {
            name: "Upcoming Task",
            data: upcoming_count,
            color: "#FFA500", // Orange for Pending
          },
          {
            name: "Completed Task",
            data: completed_count,
            color: "#008000", // Green for Completed
          },
          {
            name: "Pending Task",
            data: pending_count,
            color: "red", // Blue for In Review
          },
        ];
        setServiceUnitData({
          x_label,
          series,
        });
      } else {
        let tempData = [
          {
            id: 0,
            value: payload?.data?.inspection?.completed,
            label: "Completed Task",
            color: "green",
          },
          {
            id: 1,
            value: payload?.data?.inspection?.pending,
            label: "Pending Task",
            color: "red",
          },
          {
            id: 2,
            value: payload?.data?.inspection?.up_coming,
            label: "Upcoming Task",
            color: "orange",
          },
        ];
        setServiceUnitData(tempData);
      }
    } else {
      setServiceUnitLoading(false);
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: payload?.message || "Internal server error",
        })
      );
    }
  };
  const fetchAuditData = async () => {
    setAuditLoading(true);
    let send_payload = {};
    if (auditDateRange?.length > 0) {
      send_payload["start"] =
        auditDateRange[0] == ""
          ? undefined
          : moment(auditDateRange[0]).format("YYYY-MM-DD");
      send_payload["to"] =
        auditDateRange[1] == ""
          ? undefined
          : moment(auditDateRange[1]).format("YYYY-MM-DD");
    }

    if (auditUserTypeFilter !== "all") {
      send_payload["users"] = auditUserTypeFilter;
    }
    if (auditProjectFilter !== "all") {
      send_payload["project_id"] = auditProjectFilter;
    }
    if (mainTabAudit === 1) send_payload["interval_type "] = "month";
    else send_payload["interval_type "] = "day";

    let response = await dispatch(getAuditCountThunk(send_payload));
    const { payload } = response;

    if (payload?.status) {
      setAuditLoading(false);
      if (mainTabAudit === 1) {
        const x_label = [];
        const pending_count = [];
        const completed_count = [];
        const upcoming_count = [];

        updateData(
          payload?.data?.audit?.up_coming || [],
          upcoming_count,
          completed_count,
          pending_count,
          x_label
        );
        updateData(
          payload?.data?.audit?.completed || [],
          completed_count,
          upcoming_count,

          pending_count,
          x_label
        );
        updateData(
          payload?.data?.audit?.pending || [],
          pending_count,
          upcoming_count,
          completed_count,
          x_label
        );
        const series = [
          {
            name: "Upcoming Task",
            data: upcoming_count,
            color: "#FFA500", // Orange for Pending
          },
          {
            name: "Completed Task",
            data: completed_count,
            color: "#008000", // Green for Completed
          },
          {
            name: "Pending Task",
            data: pending_count,
            color: "red", // Blue for In Review
          },
        ];
        setAuditData({
          x_label,
          series,
        });
      } else {
        let tempData = [
          {
            id: 0,
            value: payload?.data?.audit?.completed,
            label: "Completed Task",
            color: "green",
          },
          {
            id: 1,
            value: payload?.data?.audit?.pending,
            label: "Pending Task",
            color: "red",
          },
          {
            id: 2,
            value: payload?.data?.audit?.up_coming,
            label: "Upcoming Task",
            color: "orange",
          },
        ];
        setAuditData(tempData);
      }
    } else {
      setAuditLoading(false);
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: payload?.message || "Internal server error",
        })
      );
    }
  };

  const fetchSafetyBuddyReportCount = async () => {
    let send_payload = {};
    setSafetyBuddyLoading(true);
    if (dateRange?.length > 0) {
      send_payload["start"] =
        dateRange[0] == ""
          ? undefined
          : moment(dateRange[0]).format("YYYY-MM-DD");
      send_payload["end"] =
        dateRange[1] == ""
          ? undefined
          : moment(dateRange[1]).format("YYYY-MM-DD");
    }

    if (userTypeFilter !== "all") {
      send_payload["user_id"] = userTypeFilter;
    }

    if (projectFilter !== "all") {
      send_payload["project_id"] = projectFilter;
    }
    if (mainTabsafety === 1) send_payload["type"] = "month";
    else send_payload["type"] = "day";

    let response = await dispatch(
      getDashboardSafetyBuddyCountThunk(send_payload)
    );
    const { payload } = response;

    if (payload?.status) {
      setSafetyBuddyLoading(false);

      if (mainTabsafety === 0) {
        let dates = [];
        let currentDate = new Date(dateRange[0]);
        const finalDate = new Date(dateRange[1]);

        if (currentDate > finalDate) {
          throw new Error("startDate must be before endDate");
        }

        while (currentDate <= finalDate) {
          dates.push(new Date(currentDate));
          currentDate.setDate(currentDate.getDate() + 1);
        }

        let x_label = [];
        let safety_count = [];
        let report_count = [];

        dates?.map((element) => {
          let temp_date = moment(element).format("YYYY-MM-DD");
          let safety_buddy_push = false;
          let report_push = false;

          payload?.data?.safety_buddy?.map((dateCount) => {
            if (temp_date == dateCount?.date) {
              x_label.push(temp_date);
              safety_count.push(dateCount?.count);
              safety_buddy_push = true;
            }
          });

          payload?.data?.report?.map((dateCount) => {
            if (temp_date == dateCount?.date) {
              if (!x_label.includes(temp_date)) {
                x_label.push(temp_date);
              }
              report_count.push(dateCount?.count);
              report_push = true;
            }
          });

          if (safety_buddy_push == false && report_push == true) {
            safety_count.push(0);
          }

          if (report_push == false && safety_buddy_push == true) {
            report_count.push(0);
          }
        });

        setSafetyBudddyReportData({ x_label, safety_count, report_count });
      } else {
        let x_label = [];
        let report_count = [];
        let safety_count = [];

        const updateData = (data, countArray, otherCountArray) => {
          data.forEach((item) => {
            const monthIndex = x_label.indexOf(item.month);
            if (monthIndex === -1) {
              // If month is not in x_label, add it and initialize counts for both arrays
              x_label.push(item.month);
              countArray.push(item.count); // Add the count for the current dataset
              otherCountArray.push(0); // Add 0 for the other dataset
            } else {
              // If month already exists, just update the corresponding count array
              countArray[monthIndex] = item.count;
            }
          });
        };

        updateData(payload?.data?.report || [], report_count, safety_count);
        updateData(
          payload?.data?.safety_buddy || [],
          safety_count,
          report_count
        );

        setSafetyBudddyReportData({ x_label, safety_count, report_count });
      }
    } else {
      setSafetyBuddyLoading(false);
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: payload?.message || "Internal server error",
        })
      );
    }
  };

  useEffect(() => {
    fetchDashboardCount();
    fetchAllProject();
    fetchAllServiceUnits();
  }, []);

  useEffect(() => {
    fetchDashboardReportCount();
  }, [
    reportInsideUserFilter,
    reportInsideDateRange,
    reportInsideProjectFilter,
    mainTabReport,
  ]);

  useEffect(() => {
    fetchSafetyBuddyReportCount();
  }, [userTypeFilter, dateRange, projectFilter, mainTabsafety]);

  useEffect(() => {
    fetchServiceUnitData();
  }, [
    serviceDateRange,
    serviceUserTypeFilter,
    serviceProjectFilter,
    mainTabEquipment,
  ]);
  useEffect(() => {
    fetchAuditData();
  }, [auditDateRange, auditUserTypeFilter, auditProjectFilter, mainTabAudit]);

  const safetyBuddyReportOptions = (data, title) => {
    return {
      chart: {
        type: "line", // Line chart
      },
      title: {
        text: null,
      },
      xAxis: {
        categories: data?.x_label,
        title: {
          text: mainTabsafety === 1 ? "Months" : "Day",
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "Count",
        },
      },
      series: [
        {
          name: "Safety Buddy",
          data: data?.safety_count,
          color: "#036185",
        },
        {
          name: "Report",
          data: data?.report_count,
        },
      ],
      tooltip: {
        shared: true,
        valueSuffix: " counts",
      },
      legend: {
        enabled: true,
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
          },
          enableMouseTracking: true, // Keeps the hover tooltip functional
        },
      },
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "separator",
              "downloadCSV",
              "downloadXLS",
              {
                text: "View Data Table",
                onclick: function () {
                  const tableHTML = this.getTable();
                  setGraphTitle(title);
                  showTablePopup(tableHTML); // Custom function to handle popup
                },
              },
            ],
          },
        },
      },
    };
  };

  const lineChartOptions = (data, title) => {
    // Returning the Highcharts options
    return {
      chart: {
        type: "line", // Line chart
      },
      title: {
        text: null, // Chart title
      },
      xAxis: {
        categories: data?.x_label,
        title: {
          text: "Months",
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "Count",
        },
      },
      series: data?.series,
      tooltip: {
        shared: true,
        valueSuffix: " counts",
      },
      legend: {
        enabled: true,
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
          },
          enableMouseTracking: true, // Keeps the hover tooltip functional
        },
      },
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "separator",
              "downloadCSV",
              "downloadXLS",
              {
                text: "View Data Table",
                onclick: function () {
                  const tableHTML = this.getTable();
                  setGraphTitle(title);
                  showTablePopup(tableHTML); // Custom function to handle popup
                },
              },
            ],
          },
        },
      },
    };
  };

  const pieChartOptions = (data, title) => {
    return {
      chart: {
        type: "pie",
      },
      title: {
        text: null,
      },

      series: [
        {
          name: "Reports",
          colorByPoint: true,
          data: data.map((item) => ({
            name: item.label,
            y: item.value,
            color: item.color || "#7cb5ec",
          })),
        },
      ],

      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      credits: {
        enabled: false,
      },
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "separator",
              "downloadCSV",
              "downloadXLS",
              // "viewData",
              {
                text: "View Data Table",
                onclick: function () {
                  const tableHTML = this.getTable();
                  setGraphTitle(title);
                  showTablePopup(tableHTML); // Custom function to handle popup
                },
              },
            ],
          },
        },
      },
    };
  };
  const handleMainTabChangeSafety = (event, newValue) => {
    setMainTabsafety(newValue);
  };
  const handleMainTabChangeReport = (event, newValue) => {
    setMainTabReport(newValue);
  };
  const handleMainTabChangeEquipment = (event, newValue) => {
    setMainTabEquipment(newValue);
  };
  const handleMainTabChangeAudit = (event, newValue) => {
    setMainTabAudit(newValue);
  };

  return (
    <div style={{ height: "calc(100vh - 170px)", overflowY: "auto" }}>
      <Grid container spacing={3}>
        {/* Total Users Card */}
        <Grid item xs={12} md={4}>
          <Card
            className="dashboard-card"
            onClick={() => navigate("/employees")}
          >
            <CardContent>
              <Typography variant="h5" className="dashboard-card-title">
                Total Users
              </Typography>
              {countLoading ? (
                <CircularProgress size={24} sx={{ marginTop: 2 }} />
              ) : (
                <Typography className="dashboard-card-count">
                  {dashboardCount?.user}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Total Reports Card */}
        <Grid item xs={12} md={4}>
          <Card className="dashboard-card" onClick={() => navigate("/reports")}>
            <CardContent>
              <Typography variant="h5" className="dashboard-card-title">
                Total Reports
              </Typography>
              {countLoading ? (
                <CircularProgress size={24} sx={{ marginTop: 2 }} />
              ) : (
                <Typography className="dashboard-card-count">
                  {dashboardCount?.report}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Total Safety Buddy Requests Card */}
        <Grid item xs={12} md={4}>
          <Card className="dashboard-card">
            <CardContent>
              <Typography variant="h5" className="dashboard-card-title">
                Total Safety Buddy Requests
              </Typography>
              {countLoading ? (
                <CircularProgress size={24} sx={{ marginTop: 2 }} />
              ) : (
                <Typography className="dashboard-card-count">
                  {dashboardCount?.safety_check}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Bar Chart for Safety Buddy / Report */}
        <Grid item xs={12} md={6}>
          <Card sx={{ minHeight: 400 }}>
            <CardContent>
              <Typography
                variant="h6"
                className="dashboard-card-title"
                sx={{ fontSize: "1.2rem !important", marginBottom: "8px" }}
              >
                Total Safety Buddy requests and reports
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <DateRangePicker
                    dateRange={dateRange}
                    onDateRangeChange={setDateRange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Select
                    fullWidth
                    value={userTypeFilter}
                    onChange={(e) => setUserTypeFilter(e.target.value)}
                    name="status"
                    className="dashboard-selection"
                    size="small"
                    displayEmpty
                  >
                    {userData.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={6}>
                  <Select
                    fullWidth
                    value={projectFilter}
                    onChange={(e) => setProjectFilter(e.target.value)}
                    displayEmpty
                    name="status"
                    className="dashboard-selection"
                    size="small"
                  >
                    {projectData.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <Tabs
                    value={mainTabsafety}
                    onChange={handleMainTabChangeSafety}
                    variant="fullWidth"
                    textColor="primary"
                    indicatorColor="primary"
                    className="configure-action-tab"
                    sx={{ mb: 2 }}
                  >
                    <Tab
                      label="Daily"
                      iconPosition="start"
                      sx={{ minHeight: "auto" }}
                    />
                    <Tab
                      label="Monthly"
                      iconPosition="start"
                      sx={{ minHeight: "auto" }}
                    />
                  </Tabs>
                </Grid>
                <Grid item xs={12}>
                  {safetyBuddyLoading ? (
                    <Box className="center" sx={{ minHeight: 400 }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      {safetyBudddyReportData?.x_label?.length === 0 ? (
                        <Box minHeight={400} className="center">
                          No Comparison Found
                        </Box>
                      ) : (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={safetyBuddyReportOptions(
                            safetyBudddyReportData,
                            "Total Safety Buddy requests and reports"
                          )}
                        />
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Pie Chart for Reports */}
        <Grid item xs={12} md={6}>
          <Card sx={{ minHeight: 400 }}>
            <CardContent>
              <Typography
                variant="h6"
                className="dashboard-card-title"
                sx={{ fontSize: "1.2rem !important", marginBottom: "8px" }}
              >
                Reports by status
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <DateRangePicker
                    dateRange={reportInsideDateRange}
                    onDateRangeChange={handleReportInsideDateRange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Select
                    fullWidth
                    value={reportInsideUserFilter}
                    onChange={(e) => setReportInsideUserFilter(e.target.value)}
                    className="dashboard-selection"
                    size="small"
                  >
                    {userData.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={6}>
                  <Select
                    fullWidth
                    value={reportInsideProjectFilter}
                    onChange={(e) =>
                      setReportInsideProjectFilter(e.target.value)
                    }
                    displayEmpty
                    name="status"
                    className="dashboard-selection"
                    size="small"
                  >
                    {projectData.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <Tabs
                    value={mainTabReport}
                    onChange={handleMainTabChangeReport}
                    variant="fullWidth"
                    textColor="primary"
                    indicatorColor="primary"
                    className="configure-action-tab"
                    sx={{ mb: 2 }}
                  >
                    <Tab
                      label="Total Count (%)"
                      iconPosition="start"
                      sx={{ minHeight: "auto" }}
                    />
                    <Tab
                      label="Monthly"
                      iconPosition="start"
                      sx={{ minHeight: "auto" }}
                    />
                  </Tabs>
                </Grid>
                <Grid item xs={12}>
                  {reportLoading ? (
                    <Box className="center" sx={{ minHeight: 400 }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      {mainTabReport === 1 ? (
                        reportInsideData?.x_label?.length > 0 ? (
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={lineChartOptions(
                              reportInsideData,
                              "Reports by status"
                            )}
                          />
                        ) : (
                          <Box minHeight={400} className="center">
                            No Reports Found
                          </Box>
                        )
                      ) : Array.isArray(reportInsideData) &&
                        reportInsideData?.reduce(
                          (total, item) => total + item.value,
                          0
                        ) > 0 ? (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={pieChartOptions(
                            reportInsideData,
                            "Reports by status"
                          )}
                        />
                      ) : (
                        <Box minHeight={400} className="center">
                          No Reports Found
                        </Box>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ minHeight: 400 }}>
            <CardContent>
              <Typography
                variant="h6"
                className="dashboard-card-title"
                sx={{ fontSize: "1.2rem !important", marginBottom: "8px" }}
              >
                Equipment inspections by status
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <DateRangePicker
                    dateRange={serviceDateRange}
                    onDateRangeChange={handleServiceDateRange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Select
                    fullWidth
                    value={serviceUserTypeFilter}
                    onChange={(e) => setServiceUserTypeFilter(e.target.value)}
                    className="dashboard-selection"
                    size="small"
                  >
                    {userData.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={6}>
                  <Select
                    fullWidth
                    value={serviceProjectFilter}
                    onChange={(e) => setServiceProjectFilter(e.target.value)}
                    displayEmpty
                    name="status"
                    className="dashboard-selection"
                    size="small"
                  >
                    {serviceUnits.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <Tabs
                    value={mainTabEquipment}
                    onChange={handleMainTabChangeEquipment}
                    variant="fullWidth"
                    textColor="primary"
                    indicatorColor="primary"
                    className="configure-action-tab"
                    sx={{ mb: 2 }}
                  >
                    <Tab
                      label="Total Count (%)"
                      iconPosition="start"
                      sx={{ minHeight: "auto" }}
                    />
                    <Tab
                      label="Monthly"
                      iconPosition="start"
                      sx={{ minHeight: "auto" }}
                    />
                  </Tabs>
                </Grid>
                <Grid item xs={12}>
                  {serviceUnitLoading ? (
                    <Box className="center" sx={{ minHeight: 400 }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      {mainTabEquipment === 1 ? (
                        serviceUnitData?.x_label?.length > 0 ? (
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={lineChartOptions(
                              serviceUnitData,
                              "Equipment inspections by status"
                            )}
                          />
                        ) : (
                          <Box minHeight={400} className="center">
                            No Equipment Tasks Found
                          </Box>
                        )
                      ) : Array.isArray(serviceUnitData) &&
                        serviceUnitData?.reduce(
                          (total, item) => total + item.value,
                          0
                        ) > 0 ? (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={pieChartOptions(
                            serviceUnitData,
                            "Equipment inspections by status"
                          )}
                        />
                      ) : (
                        <Box minHeight={400} className="center">
                          No Equipment Tasks Found
                        </Box>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Incident Audits Pie Chart */}
        <Grid item xs={12} md={6}>
          <Card sx={{ minHeight: 400 }}>
            <CardContent>
              <Typography
                variant="h6"
                className="dashboard-card-title"
                sx={{ fontSize: "1.2rem !important", marginBottom: "8px" }}
              >
                Incident Audits by status
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <DateRangePicker
                    dateRange={auditDateRange}
                    onDateRangeChange={handleAuditDateRange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Select
                    fullWidth
                    value={auditUserTypeFilter}
                    onChange={(e) => setAuditUserTypeFilter(e.target.value)}
                    className="dashboard-selection"
                    size="small"
                  >
                    {userData.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={6}>
                  <Select
                    fullWidth
                    value={auditProjectFilter}
                    onChange={(e) => setAuditProjectFilter(e.target.value)}
                    displayEmpty
                    name="status"
                    className="dashboard-selection"
                    size="small"
                  >
                    {projectData.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <Tabs
                    value={mainTabAudit}
                    onChange={handleMainTabChangeAudit}
                    variant="fullWidth"
                    textColor="primary"
                    indicatorColor="primary"
                    className="configure-action-tab"
                    sx={{ mb: 2 }}
                  >
                    <Tab
                      label="Total Count (%)"
                      iconPosition="start"
                      sx={{ minHeight: "auto" }}
                    />
                    <Tab
                      label="Monthly"
                      iconPosition="start"
                      sx={{ minHeight: "auto" }}
                    />
                  </Tabs>
                </Grid>
                <Grid item xs={12}>
                  {auditLoading ? (
                    <Box className="center" sx={{ minHeight: 400 }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      {mainTabAudit === 1 ? (
                        auditData?.x_label?.length > 0 ? (
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={lineChartOptions(
                              auditData,
                              "Incident Audits by status"
                            )}
                          />
                        ) : (
                          <Box minHeight={400} className="center">
                            No Audits Found
                          </Box>
                        )
                      ) : Array.isArray(auditData) &&
                        auditData?.reduce(
                          (total, item) => total + item.value,
                          0
                        ) > 0 ? (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={pieChartOptions(
                            auditData,
                            "Incident Audits by status"
                          )}
                        />
                      ) : (
                        <Box minHeight={400} className="center">
                          No Audits Found
                        </Box>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        content={modalContent}
        title={graphTitle}
      />
    </div>
  );
};

export default Insights;
